import React, { useCallback, useRef, useState } from 'react';

import { QuickFindSkeleton as QuickFindSkeletonInternal } from '@atlassian/search-page/quick-find-skeleton';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';

import { getPersistedGhostText } from './utils/getPersistedGhostText.ts';

export const QuickFindSkeleton = (): React.JSX.Element => {
	const { push } = useRouteActions();
	const inputRef = useRef<HTMLInputElement>(null);
	const [customPlaceholder] = useState(() => getPersistedGhostText(inputRef));

	const onEnter = useCallback(
		(e: React.KeyboardEvent) => {
			const input = e.target as HTMLInputElement;
			input.blur();
			push(`${CONTEXT_PATH}/search/?text=${input.value}`);
		},
		[push],
	);
	return (
		<QuickFindSkeletonInternal
			onEnter={onEnter}
			isNav4Enabled
			customPlaceholder={customPlaceholder}
			inputRef={inputRef}
		/>
	);
};

export const QuickFindAsync: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-QuickFind" */ './QuickFind.tsx')).QuickFind,
	loading: () => <QuickFindSkeleton />,
});
